var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        style: { width: _vm.width + "px", height: _vm.height + "px" },
        attrs: { id: "map" }
      },
      [
        _c(
          "v-map",
          {
            ref: "map",
            attrs: {
              zoom: _vm.zoom,
              center: _vm.center,
              minZoom: 3,
              worldCopyJump: true
            }
          },
          [
            _c("v-tilelayer", { attrs: { url: _vm.url } }),
            _vm._v(" "),
            _c("v-choropleth-layer", {
              attrs: {
                data: _vm.mapData,
                titleKey: "NUTS_NAME",
                idKey: "region_code",
                value: _vm.value,
                geojsonIdKey: "NUTS_ID",
                geojson: _vm.geoJSON,
                colorScale: _vm.colorScale,
                gradients: _vm.gradients
              },
              on: {
                "click:item": function($event) {
                  return _vm.clickItem($event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(props) {
                    return [
                      _c("v-reference-chart", {
                        attrs: {
                          title: _vm.refChart.title,
                          colorScale: _vm.colorScale,
                          min: props.min,
                          max: props.max,
                          position: "topright",
                          gradients: _vm.gradients
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3074bd5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3074bd5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = null
// module chunks = 